import { Component, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { Chart, registerables } from 'chart.js';
import { GlobalServiceService } from 'src/app/services/global/global-service.service';
import { deepMerge } from 'src/app/helpers/transformation-utils';
Chart.register(...registerables);

@Component({
    selector: 'app-chart-cl',
    templateUrl: './chart-cl.component.html',
    styleUrls: ['./chart-cl.component.scss'],
    standalone: false
})
export class ChartClComponent implements OnInit, OnDestroy {
  @Input()
  public data: any;

  @Input()
  public labels: any;

  @Input()
  public indexAxis: string = 'y';

  @Input()
  public type: string = 'bar';

  @Input()
  public backgroundColor: string = '#42A5F5';

  @Input()
  public borderColor: string = '#42A5F5';

  @Input()
  public borderWidth: number = 5;

  @Input()
  public pointRadius: number = 10;

  @Input()
  public datasetLabel: string = '';

  @Input()
  public animationDuration: number = 1500;

  @Input()
  public animationEasing: string = 'easeInOutQuart';

  @Input()
  public customChartOptions: any = {};

  chartsPuntaje: Chart<'line', any[], unknown>;
  domElementPuntaje: any;
  subscription: any;
  subscriptionDestroy: any;

  constructor(
    private readonly _elementRef: ElementRef,
    public globalServiceService: GlobalServiceService
  ) {}

  ngOnInit() {
    this.puntaje();
    this.subscriptionDestroy =
      this.globalServiceService.chartDestroy$.subscribe((n: boolean) => {
        if (n) {
          this.destroy();
        }
      });
    this.subscription = this.globalServiceService.chart$.subscribe((c: any) => {
      if (c.change) {
        this.data = c.data;
        this.labels = c.labels;
        this.puntaje();
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.subscriptionDestroy?.unsubscribe();
  }

  destroy() {
    if (this.chartsPuntaje?.data?.datasets) {
      this.chartsPuntaje.data.labels = [];
      this.chartsPuntaje.data.datasets[0].data = [];
      this.labels = [];
      this.data = [];
      this.chartsPuntaje.update();
      this.chartsPuntaje?.destroy();
    }
  }

  puntaje() {
    this.domElementPuntaje =
      this._elementRef.nativeElement.querySelector(`#chartsPuntaje`);
    this.domElementPuntaje.width = 800;
    this.domElementPuntaje.height = 200;
    this.chartsPuntaje?.destroy();
    this.chartsPuntaje = new Chart(this.domElementPuntaje, {
      type: 'line',
      data: {
        labels: this.labels,
        datasets: [
          {
            label: this.datasetLabel || 'Puntaje',
            data: this.data,
            backgroundColor: this.backgroundColor,
            borderColor: this.borderColor,
            borderWidth: this.borderWidth,
            pointRadius: this.pointRadius,
            pointBackgroundColor: this.borderColor,
            pointBorderColor: this.borderColor,
            pointBorderWidth: 2,
            fill: false,
            tension: 0.1,
            clip: false,
          },
        ],
      },
      options: this.mergeOptions({
        responsive: true,
        indexAxis: 'x',
        animation: {
          duration: this.animationDuration,
          easing: this.animationEasing as any,
        },
        interaction: {
          intersect: false,
          mode: 'index',
        },
        onHover: (event: any, activeElements: any) => {
          const target = event.native?.target as HTMLElement;
          if (target) {
            target.style.cursor =
              activeElements.length > 0 ? 'pointer' : 'default';
          }
        },
        plugins: {
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              usePointStyle: true,
              pointStyle: 'line',
              padding: 20,
              font: {
                size: 14,
                family: 'Inter, sans-serif',
              },
            },
          },
        },
        scales: {
          x: {
            stacked: true,
          },
          y: {
            stacked: true,
          },
        },
      }),
    });
    this.chartsPuntaje.update();
  }

  /**
   * Deep merge default options with custom options
   */
  private mergeOptions(defaultOptions: any): any {
    if (
      !this.customChartOptions ||
      Object.keys(this.customChartOptions).length === 0
    ) {
      return defaultOptions;
    }
    return deepMerge(defaultOptions, this.customChartOptions);
  }
}
